var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4.99998H19H17V1.99998C17 1.44798 16.553 1 16 1H9C8.44702 1 8.00002 1.44798 8.00002 1.99998V4.99998H6.00001H3.99999C3.447 4.99998 3 5.44797 3 5.99997C3 6.55197 3.44695 7 3.99999 7H4.99997V19C4.99997 20.654 6.34599 22 7.99998 22H17C18.654 22 20 20.654 20 19V7H21C21.553 7 22 6.55202 22 6.00002C22 5.44802 21.553 4.99998 21 4.99998ZM9.99999 3.00002H15V5.00003H9.99999V3.00002ZM17 20H7.99998C7.44798 20 7 19.551 7 19V7H10H15H18.0001V19C18 19.551 17.552 20 17 20ZM9.99999 9.00002C9.44701 9.00002 9 9.448 9 10V17C9 17.552 9.44701 18 9.99999 18C10.553 18 11 17.552 11 17V10C11 9.448 10.553 9.00002 9.99999 9.00002ZM14 10C14 9.448 14.447 9.00002 15 9.00002C15.553 9.00002 16 9.448 16 10V17C16 17.552 15.553 18 15 18C14.447 18 14 17.552 14 17V10Z",
    fill: "#989DAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDisabled);
export default __webpack_public_path__ + "static/media/trash-disabled.6f85a0dccada62254f9671d30f0174c2.svg";
export { ForwardRef as ReactComponent };